import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, fetchDeletePromisedData, getDropdownIdsFromSelectArray } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../views/pages/manage/common/constant";
import { transferTypes } from "./addEditCofigDialog/utils";

export const getDropdowns = async () => {
  try {
    const resp = await Promise.all([
      dropdownMapping(
        endpoint.businessArea.getAllActive,
        "businessAreaDispValue",
        "id",
        "regionId"
      ),
      dropdownMapping(
        endpoint.region.getAllActive,
        "regionDispValue",
        "id"
      ),
      dropdownMapping(
        endpoint.academic_career.getAllActive,
        "academicCareerDispValue",
        "id"
      ),
      dropdownMapping(
        endpoint.getRole.roleWithApprovalPermissions,
        "roleName",
        "id",
      ),

    ]);
    return {
      allActiveBu: resp[0],
      allActiveRegions: resp[1],
      allActiveCareers: resp[2],
      allActiveRoles: resp[3],
    };
  } catch (err) {
    console.error(err);
  }
}



export const getConfigs = async (filterReqObj) => {
  return await fetchAllPostPromisedData(endpoint.transferConfig.search, filterReqObj);
}

export const createConfig = async (form) => {
  let reqObj = createTransferConfigReqObj(form);
  return await fetchAllPostPromisedData(endpoint.transferConfig.basePath, reqObj);
}

export const updateConfig = async (form) => {
  let reqObj = createTransferConfigReqObj(form);
  return await fetchAllPostPromisedData(endpoint.transferConfig.basePath, reqObj, 'put');
}

export const deleteConfig = async (id) => {
  return await fetchDeletePromisedData(`${endpoint.transferConfig.delete}/${id}?type=transferApproval`, true);
}

export const getFormattedTransferConfig = (config, dropdownData) => {

  const { businessAreas, academicCareers, transferTypeRoleMappingDtoList, id, updatedOn, updatedBy } = config;
  const { allActiveBu, allActiveCareers, allActiveRoles, allActiveRegions } = dropdownData;

  const updatedConfig = {
    id,
    updatedOn,
    updatedBy,
    businessArea: businessAreas?.map(buId => allActiveBu?.find(el => el?.value === buId)),
    academicCareer: academicCareers?.map(careerId => allActiveCareers?.find(el => el?.value === careerId)),
    approvalSettingDTO: transferTypeRoleMappingDtoList?.map((el,index) => {
      const { transferType, l1ApprovalRoles, l2ApprovalRoles } = el;
      return {
        id : index,
        transferType: transferTypes?.find(el => el?.value === transferType),
        l1Roles: l1ApprovalRoles?.map(roleId => allActiveRoles?.find(el => el?.value == roleId)),
        l2Roles: l2ApprovalRoles?.map(roleId => allActiveRoles?.find(el => el?.value == roleId)),
      }

    })
  }

  updatedConfig.regions = allActiveRegions?.filter(region => updatedConfig.businessArea?.find(bu => bu?.regionId?.includes(region?.value)));

  return updatedConfig;
}


const createTransferConfigReqObj = form => {

  const { businessArea, academicCareer, approvalSettingDTO, isNew, id } = form;

  return {
    ...(!isNew && { id }),
    businessAreas: getDropdownIdsFromSelectArray(businessArea),
    academicCareers: getDropdownIdsFromSelectArray(academicCareer),
    transferTypeRoleMappingDtoList: approvalSettingDTO?.map(el => {
      const { transferType, l1Roles, l2Roles } = el;
      return {
        transferType: transferType?.value,
        l1ApprovalRoles: getDropdownIdsFromSelectArray(l1Roles),
        l2ApprovalRoles: getDropdownIdsFromSelectArray(l2Roles),
      }
    })

  }

}

export const getFilterReqObj = (filters, allActiveBu) => {
  const {transferTypes = [] , businessAreas = []} = filters;
  const filterBUs = businessAreas?.length ? businessAreas : allActiveBu

  return {
    transferTypes : getDropdownIdsFromSelectArray(transferTypes),
    businessAreas : getDropdownIdsFromSelectArray(filterBUs)
  }
}
